export const version = {
  timeStamp: '2026-10-20 10:06:34 AM -03',
  version: '0.0.13-20261020100634',
}
